var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 18.8556C19.323 18.9754 21.5999 12.119 21.5999 12.119C21.5999 12.119 19.4153 5.14288 11.9999 5.14288C4.58452 5.14288 2.3999 12.119 2.3999 12.119C2.3999 12.119 4.67683 18.7359 11.9999 18.8556Z",
    stroke: "#42485A",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3 12C14.3 13.2898 13.2255 14.3354 11.9 14.3354C10.5745 14.3354 9.5 13.2898 9.5 12C9.5 10.7102 10.5745 9.66464 11.9 9.66464C13.2255 9.66464 14.3 10.7102 14.3 12Z",
    stroke: "#42485A",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.77f1b17e34c03e7b34845cea18374756.svg";
export { ForwardRef as ReactComponent };